import React from 'react';
import AppLoading from '../../AppLoading';

interface LoadingOverlayProps {
  isLoading: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div style={{
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 10,
      top: '60px',
      display: 'flex',
      position: 'absolute',
      alignItems: 'center',
      pointerEvents: 'none',
      justifyContent: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
    }}>
      <AppLoading style={{ height: "100%", width: "100%" }} />
    </div>
  );
};

export default LoadingOverlay;
